<template>
	<div id="app">
		<transition name="router-fade" mode="out-in">
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
			</keep-alive>
    	</transition>
    	<transition name="router-fade" mode="out-in">
			<router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
		</transition>
	</div>
</template>

<script>
	export default {
  		name: 'App',
		components: {
		},
		watch: {
			$route(to) {
				var ilanguage = this.util.getStorage('ilanguage');
				var url = window.location.href;
				var newUrl = url;
				var urls = url.split('/');
				var index = urls.indexOf('template');
				if(index > 0) {
					var dir = urls[index + 1];
					if(ilanguage == 'zh-HK' && dir != 'vue_zh_HK') {
						urls[index + 1] = 'vue_zh_HK';
					} else if(ilanguage == 'zh-CN' && dir != 'vue') {
						urls[index + 1] = 'vue';
					}
					newUrl = urls.join('/');
					if(newUrl != url) {
						window.location.href = newUrl;
					}
				}
			}
		}
	}
</script>

<style>
	body{
		background-color: #f5f5f5;
	}
	.router-fade-enter-active, .router-fade-leave-active {
		/*transition: opacity .3s;*/
	}
	.router-fade-enter, .router-fade-leave-active {
	  	opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue